import apiService from "@/services/api.service";
import type { NotificationsResponse, UnreadCountResponse } from "@/types/notification.types";

export async function fetchNotifications(params: { page?: number; limit?: number; unreadOnly?: boolean } = {}) {
  const { page = 1, limit = 20, unreadOnly = false } = params;
  const query = new URLSearchParams({
    page: String(page),
    limit: String(limit),
    unreadOnly: String(unreadOnly),
  });
  return apiService.get<NotificationsResponse>(`/notifications?${query}`);
}

export async function fetchUnreadCount() {
  return apiService.get<UnreadCountResponse>("/notifications/unread-count");
}

export async function markAsRead(id: string) {
  return apiService.patch<{ success: boolean }>(`/notifications/${id}/read`);
}

export async function markAllAsRead() {
  return apiService.patch<{ success: boolean }>("/notifications/read-all");
}
